import { useQuery } from "react-query";
import React, { memo, useState } from "react";
import HotCarItem from "../HotCarItem";
import { fetchKindsPcRecommendKinds } from "@Services/home";
import { IKindsPcRecommendKinds } from "@Types/api";

const HotInquiry = () => {
  const [visible, setVisible] = useState<boolean>(true);
  const initData: IKindsPcRecommendKinds["items"] = [];
  const { data = initData } = useQuery<IKindsPcRecommendKinds["items"]>([`fetchKindsPcRecommendKinds`], async () => {
    const res = await fetchKindsPcRecommendKinds({ limit: 4, ads: 1 });

    if (res?.status === 12000) {
      const isTure = res.data.items.some((item) => item.discountTitle !== "");
      setVisible(isTure);
      return res.data.items;
    }
    return initData;
  });

  return (
    <>
      <div className={"w-full mx-auto relative min-h-300"}>
        <p className='text-24 font-black text-black leading-34 mb-20 flex items-center'>推薦車款</p>
        <div id="tracking-ModelsRecommendKind" className={"mt-20 grid grid-cols-4 gap-24"}>
          {data?.length > 0 &&
            data.map((item: any, index: number) =>
              <React.Fragment key={index}>
                <HotCarItem item={item} key={index} visible={visible} />
              </React.Fragment>
            )}
        </div>
      </div>
    </>
  );
};

export default memo(HotInquiry);
